<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm8 md4 offset-sm2 offset-md4>
        <h1>Login</h1>
      </v-flex>
    </v-layout>
    <v-form ref="form" @submit.prevent="onSignIn">
      <v-layout row wrap>
        <v-flex xs12 sm8 md4 offset-sm2 offset-md4>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            @blur="validateEmail()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm8 md4 offset-sm2 offset-md4>
          <v-text-field
            id="password"
            v-model="password"
            :rules="pswRules"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            label="Password"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm8 md4 offset-sm2 offset-md4>
          <v-btn type="submit" :disabled="!valid" color="success" :loading="loading">Conferma</v-btn>

          <v-btn color="error" @click="reset">Annulla</v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <v-layout row wrap>
      <v-flex xs12 sm8 md4 offset-sm2 offset-md4 mt-3>
        <v-btn flat color="success" router :to="'/signup'">Registrati Qui</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm8 md4 offset-sm2 offset-md4 mt-3>
        <ResetPassword />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm8 md4 offset-sm2 offset-md4 mt-3>
        <p class="validationError">{{ messageVerified }}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { FormMixin } from "../mixins/FormMixin";
import ResetPassword from "../components/ResetPasswordDialog.vue";
import { bus } from "../main";
import * as firebase from "firebase";
import { db } from "../main";
export default {
  mixins: [FormMixin],
  components: { ResetPassword },
  data: () => ({
    show: false,
    valid: true,
    remember: false,
    messageVerified: "",
    messageAuthorized: "",
    loading: false,
    email: "",
    emailRules: [v => !!v || "Email necessaria"],
    password: "",
    pswRules: [v => !!v || "Password necessaria"]
  }),

  methods: {
    //metodo per la pulizia dei campi del form
    reset() {
      this.$refs.form.reset();
      this.messageVerified = "";
      this.messageAuthorized = "";
    },

    //metodo per il login dell'utente con controllo della validità dell'email e dell'autorizzazione
    onSignIn() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            var authorized = "0";
            var signedIn = [];
            const user = firebase.auth().currentUser;
            this.messageVerified = "";
            this.messageAuthorized = "";
            db.collection("utenti")
              .doc(user.uid)
              .get()
              .then(doc => {
                authorized = doc.data().autorizzato;
                if (!user.emailVerified) {
                  this.messageVerified =
                    "Email inserita in attesa di verifica, controllare la propria casella postale!";
                  this.loading = false;
                } else {
                  db.collection("utenti")
                    .doc(user.uid)
                    .update({
                      verificato: "1"
                    })
                    .catch(error => {
                      this.loading = false;
                      bus.$emit(
                        "errorOperation",
                        "Errore: problema nella validazione dell'utente(" +
                          error +
                          ")"
                      );
                    });
                }
                if (user.emailVerified === true) {
                  this.$store.dispatch("setUserLoged").then(() => {
                    this.$store.dispatch("setRole", doc.data().ruolo);
                    this.$store.dispatch("setAuthorized", authorized);
                    db.collection("iscritti")
                      .get()
                      .then(list => {
                        list.forEach(element => {
                          if (element.data().id_utente == user.uid) {
                            signedIn.push(element.data().id_corso);
                          }
                        });
                        this.$store
                          .dispatch("setRegisteredCourses", signedIn)
                          .then(() => {
                            bus.$emit(
                              "successfullOperation",
                              "Loggato con successo"
                            );
                            this.loading = false;
                            this.$router.replace("home");
                          });
                      })
                      .catch(error => {
                        this.loading = false;
                        bus.$emit(
                          "errorOperation",
                          "Errore: problema nel caricamento dei corsi a cui l'utente è iscritto" +
                            error
                        );
                      });
                  });
                }
              })
              .catch(() => {
                this.loading = false;
                bus.$emit(
                  "errorOperation",
                  "Errore: Email inserita in attesa di verifica, controlare la propria casella postale!"
                );
              });
          })
          .catch(() => {
            this.loading = false;
            bus.$emit("errorOperation", "Errore: Email o Password errati");
          });
        if (this.messageVerified !== "") {
          this.loading = false;
          firebase.auth().signOut();
        }
      }
    }
  }
};
</script>